import { UserPlus } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { RequestLayout } from '@/components/layout/RequestLayout';
import { SurveyFormRenderer } from '@/components/registration/SurveyFormRenderer';
import { useLocalization } from '@/contexts/LocalizationContext';

function RegisterPageContent() {
  const { t } = useLocalization();

  return (
    <div className="space-y-6">
      <Card className="shadow-lg">
        <CardHeader className="space-y-3 text-center pb-8">
          <div className="flex justify-center mb-4">
            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
              <UserPlus className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl sm:text-3xl font-bold">
            {t('registration.title')}
          </CardTitle>
          <CardDescription className="text-base">
            {t('registration.subtitle')}
          </CardDescription>
        </CardHeader>
      </Card>

      {/* Public registration: never pass providersPageOrganizationEntityId (dashboard-only). */}
      <SurveyFormRenderer profileType="provider" defaultProviderType="flex" />
    </div>
  );
}

export function RegisterPage() {
  return (
    <RequestLayout>
      <RegisterPageContent />
    </RequestLayout>
  );
}
